import { gql } from '@apollo/client'

export const PUBLISHER_NAMES = gql`
    query PublisherNames {
        getPublishersFromPostgres {
            id
            name
        }
    }
`

export const AD_LOCALES = gql`
    query AdLocales($publisherId: ID!, $campaignId: ID!, $query: String) {
        adLocales(publisher_id: $publisherId, campaign_id: $campaignId, query: $query) {
            available
            locales {
                key
                name
            }
        }
    }
`

export const ACCOUNT_SIGNALS = gql`
    query AccountSignals($publisherId: ID!, $campaignId: ID!, $objective: String, $refresh: Boolean) {
        accountSignals(publisher_id: $publisherId, campaign_id: $campaignId, objective: $objective, refresh: $refresh) {
            checked_at
            events_window_days
            pixel_id
            pixel_status
            pixel_name
            pixel_last_fired_time
            pixel_shared_with_ad_account
            events_status
            events {
                event
                count
                last_seen
            }
            conversions_api_status
            conversions_api_events {
                event
                count
            }
            custom_audience_terms
            terms_accepted
            dataset_quality_status
            dataset_quality {
                event
                match_quality
                coverage
                upload_frequency
            }
            findings {
                level
                code
                message
            }
        }
    }
`

export const AUDIENCE_READINESS = gql`
    query AudienceReadiness($publisherId: ID!, $campaignId: ID!, $objective: String, $refresh: Boolean) {
        audienceReadiness(
            publisher_id: $publisherId
            campaign_id: $campaignId
            objective: $objective
            refresh: $refresh
        ) {
            available
            message
            checked_at
            objective
            level
            level_label
            level_reason
            level_rules
            events_window_days
            components {
                key
                label
                status
                value
                note
            }
            events {
                event
                status
                count
                last_seen
            }
            audiences {
                purpose
                kind
                label
                status
                approximate_count_lower
                message
                eligible
                checked_at
            }
            min_seed_size
            switches {
                key
                label
                on
            }
            paths {
                key
                label
                status
                reason
            }
            summary_text
        }
    }
`
